import { Controller } from "stimulus"

// Toggle visibility of content sections.
//
// Usage (basic show/hide):
//   .div{"data-controller" => "toggle"}
//     %button{"data-action" => "click->toggle#toggle"} Show/Hide
//     .div{"data-toggle-target" => "content", class: "d-none"}
//       Content here
//
// Usage (with custom CSS class):
//   .div{"data-controller" => "toggle", "data-toggle-class-value" => "visually-hidden"}
//     %button{"data-action" => "click->toggle#toggle"} Toggle
//     .div{"data-toggle-target" => "content"}
//       Content here
//
export default class extends Controller {
  static targets = ["content", "icon"]
  // { type, default } shorthand throws on this app's Stimulus version and aborts controller loading site-wide -- bare type + manual fallback instead
  static values = {
    class: String
  }

  toggle() {
    var klass = this.hasClassValue ? this.classValue : "d-none"
    this.contentTargets.forEach(function(el) {
      el.classList.toggle(klass)
    })

    // Rotate icon if present (e.g. chevron)
    this.iconTargets.forEach(function(el) {
      el.classList.toggle("fa-rotate-180")
    })
  }

  show() {
    var klass = this.hasClassValue ? this.classValue : "d-none"
    this.contentTargets.forEach(function(el) {
      el.classList.remove(klass)
    })
  }

  hide() {
    var klass = this.hasClassValue ? this.classValue : "d-none"
    this.contentTargets.forEach(function(el) {
      el.classList.add(klass)
    })
  }
}
